import React, { Component } from 'react';
import Logo from '../../shared/logo.png';
import './construction.css';

export default class Construction extends Component {
  render() {
    return (
      <div className="Home">
        <div className="Home-img">
          <img src={Logo} alt="Codelab DWM" style={styles.img} />
          <p style={styles.p}>em manutenção</p>
        </div>
      </div>
    );
  }
}

const styles = {
  home: {
    display: 'flex',
  },
  img: {
    maxWidth: '450px',
    width: '100%',
  },
  p: {
    textAlign: 'center'
  }
}



// WEBPACK FOOTER //
// ./src/pages/Construction/index.js